import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';

export const structureRoute: RouteConfig = {
  path: 'structure',
  name: 'structureList',
  component: () => import(/* webpackChunkName: "StructureList" */ '@/views/mainRoute/structure/List.vue'),
  meta: {
    breadcrumb: {
      title: 'Jednostki oświatowe',
      name: 'structureList'
    },
    config: {
      title: 'Jednostki oświatowe',
      name: 'structureList',
      icon: 'fa-home',
      permissions: ['STRUCTURE_NODE.UPDATE']
    }
  },
  beforeEnter: (to, from, next) => {
    store
      .dispatch('structureNode/list', { root: true, count: -1 })
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.STRUCTURE_CANNOT_LIST }));
  }
};
